import api from '../../../../api'
import { TFunction } from 'react-i18next'
import { store } from '../../../../store'
import { campaignEmissionScheduleActions } from '../store/campaign-emission-schedule-slice'

export default class CreationsFormPercentageShareService {
  static update = (
    creationId: string,
    percentageShare: string,
    setErrors: React.Dispatch<React.SetStateAction<string[]>>,
    t: TFunction
  ) => {
    store.dispatch(campaignEmissionScheduleActions.setEmissionsNumberLoading(true))

    // if percentageShare is not a valid number, set percentageShare to null, otherwise change "80" to "0.8"
    const percentageShareValue = isNaN(Number(percentageShare))
      ? null
      : (Number(percentageShare) / 100).toString()

    api.creation
      .updateCreationPercentageShare(creationId, percentageShareValue)
      .catch(errors => {
        if (errors) {
          setErrors([t('form.campaign.creations.invalidCreationEmissions')])
        }
      })
      .finally(() => {
        store.dispatch(campaignEmissionScheduleActions.setEmissionsNumberLoading(false))
      })
  }
}
